const ROUTE_ID_FIELDS = [
  "uuid",
  "neuronUuid",
  "neuron_item_uuid",
  "neuronItemId",
  "itemId",
  "entityId",
  "entity_id",
  "id",
];
const EXTRA_ID_FIELDS = ["vectorId"];

const normaliseId = (value) => {
  if (typeof value !== "string" && typeof value !== "number") {
    return null;
  }

  const trimmed = String(value).trim().toLowerCase();
  return trimmed || null;
};

export const getStoryRouteId = (story) => {
  if (!story || typeof story !== "object") {
    return null;
  }

  return (
    ROUTE_ID_FIELDS.map((field) => story[field])
      .map(normaliseId)
      .find(Boolean) ??
    EXTRA_ID_FIELDS.map((field) => story[field])
      .map(normaliseId)
      .find(Boolean) ??
    null
  );
};

export const getStoryIdentifierSet = (story) => {
  const identifiers = new Set();

  const routeId = getStoryRouteId(story);
  if (routeId) {
    identifiers.add(routeId);
  }

  EXTRA_ID_FIELDS.forEach((field) => {
    const identifier = normaliseId(story?.[field]);
    if (identifier) {
      identifiers.add(identifier);
    }
  });

  return identifiers;
};

export const findStoryByRecommendationId = (stories, recommendationId) => {
  const targetId = normaliseId(recommendationId);
  if (!targetId || !Array.isArray(stories)) {
    return null;
  }

  return (
    stories.find((story) => getStoryIdentifierSet(story).has(targetId)) ?? null
  );
};

export const findStoryByRouteParam = (stories, routeParam) => {
  return findStoryByRecommendationId(stories, routeParam);
};
